import { TDeviceType } from '@cian/ui-kit';

import { EPageType, IPageState } from '../../types/redux/page';
import { EDealType } from '../../types/dealType';
import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../constants/actionTypes/page';

export const initialState: IPageState = {
  deviceType: 'desktop' as TDeviceType,
  subdomain: 'www',
  dealType: EDealType.Sale,
  queryParams: {
    valuationType: EDealType.Sale,
    address: '',
    roomsCount: 1,
    totalArea: 2,
  },
  pageType: EPageType.Calculator,
  isWebview: false,
  stickyFooterVisible: true,
  isFromOfferCard: false,
  isFromMyHome: false,
  cta: { isOpen: false },
};

export function pageReducer(state = initialState, action: TReduxActions): IPageState {
  switch (action.type) {
    case EActionTypes.SetQP:
      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          ...action.payload,
        },
      };

    case EActionTypes.SetDealType:
      return {
        ...state,
        dealType: action.payload,
      };

    case EActionTypes.ToggleStickyFooterVisible:
      return {
        ...state,
        stickyFooterVisible: action.payload,
      };

    case EActionTypes.SetPageCta:
      return {
        ...state,
        cta: {
          ...state.cta,
          ...action.payload,
        },
      };

    case EActionTypes.ClearIsFromOfferCard:
      return {
        ...state,
        isFromOfferCard: false,
      };

    case EActionTypes.SetMinGeoId:
      return {
        ...state,
        minGeoId: action.payload,
      };

    case EActionTypes.SetPageType:
      return {
        ...state,
        pageType: action.payload,
      };

    default:
      return state;
  }
}
